import { to } from '@tencent/wphk-base-utils';
import { useActCycle } from '../hooks/use-act-cycle';
import { windowHelper } from '@tencent/ppd-base-libs';

const FOODPANDA_SHARE_URL = 'https://prom.wechatpay.com.hk/foodpanda-share/index.shtml';

export const checkFoodpandaActCycle = async () => {
  const { initActCycleConf, isInAct } = useActCycle();
  await to(initActCycleConf());

  if (isInAct.value) {
    // 如果是活动时间则重定向到foodpanda页
    redirectToFoodpanda();
    return { isContinue: false };
  }
  // 如果actCycle获取失败 或 不处于活动期间，则不重定向
  return { isContinue: true };
};


const redirectToFoodpanda = () => {
  windowHelper.replace(FOODPANDA_SHARE_URL + location.search + location.hash);
};
